import { Model }    from 'backbone';
import undoService	from 'UndoService.js'
import controlCollection    from 'ControlCollection.js'
import connectionController from 'ConnectionController.js';
import listService from 'ListService';
import constants from 'Constants';
import textConstants        from 'TextConstants';

class BehaviorModel extends Model {

    initialize() {
    	//console.log('init BehaviorModel');
    	//TODO: set Current Visual Control Model id as an attribute
        this.set({
            'widgetText': ''
        } );

        controlCollection.add(this);

        this.lastState(this.toJSON());
        
        this.set('undoAction', false, {silent: true});
       
        this.on('loadRelatedFields', (params) => {
            this.getRelatedObjects(params);
        });

        this.on('change', function(params){

            this.getRelatedObjects(params);

            if(this.get('undoAction')){
                this.lastState(this.toJSON());
                this.set('undoAction', false, {silent: true});
            } else {
                const lastState = this._lastState;
                const newState = JSON.stringify(this.toJSON());

                undoService.add({
                    undo: () => {
                        const oldX = this.get('x');
                        const oldY = this.get('y');
                        this.set(JSON.parse(lastState), {silent: true});
                        // we want to ignore what was set for this, this is important to not register another undo
                        this.set('undoAction', true, {silent: true});
                        // we trigger change because all views listening need to update
                        this.trigger('change');

                        if (listService.mainKind === constants.KIND_BEHAVIORS) {
                            connectionController.updateConnection(this, {
                                x1: this.get('x'),
                                x2: oldX,
                                y1: this.get('y'),
                                y2: oldY
                            });
                        }
                    },
                    redo: ()=>{
                        const oldX = this.get('x');
                        const oldY = this.get('y');
                        this.set(JSON.parse(newState), {silent: true});
                        // we want to ignore what was set for this, this is important to not register another undo
                        this.set('undoAction', true, {silent: true});
                        // we trigger change because all views listening need to update
                        this.trigger('change');

                        if (listService.mainKind === constants.KIND_BEHAVIORS) {
                            connectionController.updateConnection(this, {
                                x1: this.get('x'),
                                x2: oldX,
                                y1: this.get('y'),
                                y2: oldY
                            });
                        }
                    }
                }, textConstants.UNDO_PROP_CHANGE);

                this.lastState(this.toJSON());
            }
        });
    }

    findFieldsInFormula(args, fields, addField){   
        let fieldId = "";     
        _.forEach(args, (arg) =>{  
            if(arg.children){
               this.findFieldsInFormula(arg.children, fields, addField);
            }
            else{
                if(arg.type === "scripting_formField"){

                    fieldId = arg.fieldId;
                    if(fieldId.indexOf("$") > -1){
                        fieldId = fieldId.split("$")[0];
                    }
                    addField(fieldId);
                }
            }
        });
    }

    getRelatedObjects(parameters){

        const aux = this.get('relatedFields');
        const relatedFields = aux ? !Array.isArray(aux) ? aux.split(',') : aux : [];

        const addField = (id) => {
            if(!relatedFields.includes(id)){
                relatedFields.push(listService.cleanId(id)) 
            }
        };

        const getField = (fieldId) =>{
            if(fieldId && fieldId !== ""){
               addField(fieldId) 
            }
        };

        //PF-6630 Check from Show Page command
        if(this.get("factoryKey") === "command_show_page"){
            if(this.get("pageType") === "specific"){
                addField(this.get("page"));
            }
        }
        
        //PF-6630 Check from Print command
        if(this.get("factoryKey") === "command_print"){
            if(this.get("pageType") === "specific"){

                const pages = this.get("pageIds").split(",");

                _.each(pages, (page) => {
                    addField(page);
                });               
            }
        }

        //The selected field could be on the fieldId attribute or in the selected attribute
        let fieldId = this.get("fieldId") || this.get("controlId");
        if (!fieldId) {
            if(this.get("selected")){
                fieldId = this.get("selected").id;
            }
        }
        getField(fieldId);

        //Check grid data in case there are fields in that attribute
        const data = this.get('gridData');
        if(data){
            data.forEach((field) => {
                if(field.id){
                    addField(field.id);
                }
            });
        }

        //Check the parameters for all behaviors, if the parameters variable has a value is coming from a line connector of multi branch
        const params = parameters || this.get("Parameters");
        if (params && params.Parameter) {
            const param = params.Parameter[0];
            if (param) {
                if (param.Expression && param.type.toLowerCase() === "expression") {
                    this.findFieldsInFormula(param.Expression.arguments, relatedFields, addField);
                }
                else {
                    if (param.field) {
                        addField(param.field);
                    }
                    else {
                        getField(this.get("selectedFieldId"));
                    }
                }
            }
        }

        //Check Property for copyFields command
        const property = this.get("Property");
        if (property) {
            _.each(property, (prop) => {
                if (prop.Item) {
                    _.each(prop.Item, (value) => {
                        addField(value._value || value);
                    })
                }
            });
        }

        //Check from notifications
        const notifications = this.get("notifications");
        if (notifications) {
            _.each(notifications, (notification) => {
                getField(notification.personEmailFieldId);
                getField(notification.activationDateField);
                getField(notification.activationPeriodAmountFieldId);
            });
        }
        getField(this.get("cancelNotificationId"));

        //Check formulaParameters for all behaviors
        const formulaParams = this.get("formulaParameter");
        if (formulaParams && formulaParams.arguments && (this.get("conditionType") === "advanced" || this.get("type") === "scriptingCondition")) {
            this.findFieldsInFormula(formulaParams.arguments, relatedFields, addField);
        }
       
       this.set("relatedFields", relatedFields, {silent: true});
    }

    lastState(state){
        this._lastState = JSON.stringify(state);
    }

    resetLastState() {
        this.lastState(this.toJSON());
    }
}

export default BehaviorModel;

